import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';
import { IS_ANDROID } from '@/utils/platform';

export const styles = StyleSheet.create({
  container: {
    gap: 12,
    paddingVertical: theme.spacings.md,
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 20,
  },
  nameWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flex: 1,
  },
  nameColumn: {
    flex: 1,
    gap: theme.spacings.xs,
  },
  profile: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: 'center',
    flexShrink: 0,
  },
  profileName: {
    fontSize: 18,
    letterSpacing: 3,
    marginRight: IS_ANDROID ? 0 : -3,
    textAlign: 'center',
    includeFontPadding: false,
  },
  nameText: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.newUI.therapist.textBlue100,
    flexShrink: 1,
  },
  actions: {
    flexDirection: 'column',
    gap: theme.spacings.sm,
    paddingTop: 6,
    flexShrink: 0,
    alignItems: 'flex-end',
  },
  tagsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacings.xs,
    paddingHorizontal: 20,
  },
  tag: {
    borderWidth: 0,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  metaText: {
    fontSize: 14,
    color: colors.darkGrey,
  },
  metaSeparator: {
    fontSize: 14,
    color: colors.newUI.therapist.grey50,
  },
  codeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacings.xs,
  },
  codeDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  createdText: {
    fontSize: 13,
    color: colors.newUI.therapist.grey60,
  },
  divider: {
    height: 1,
    backgroundColor: colors.newUI.therapist.grey20,
    marginVertical: theme.spacings.xs,
  },
  notesSection: {
    gap: theme.spacings.sm,
    paddingHorizontal: 20,
  },
  notesSectionTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: colors.newUI.therapist.textBlue100,
  },
  notesText: {
    fontSize: 14,
    color: colors.darkGrey,
    lineHeight: 20,
  },
  expandButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacings.xs,
    paddingHorizontal: 20,
  },
  expandButtonText: {
    fontSize: 14,
    color: colors.newUI.therapist.primaryBlue60,
    fontWeight: '600',
  },
});
